import { SET_AZURE, CLEAR_AZURE } from "../actions/azureActions";

const initialState = {
  azure: []
}

function azureReducer(state = initialState, action) {
  switch (action.type) {
  case SET_AZURE:
    return {
      ...state,
      azure: action.payload
    }
  case CLEAR_AZURE:
    return {
      ...state,
      azure: []
    }
  default:
    return state;
  }
}

export default azureReducer;